import React, { createContext } from "react";

export const ExpenseReportsContext = createContext(null);

export function ExpenseReportsProvider({ value, children }) {
  return <ExpenseReportsContext.Provider value={value}>{children}</ExpenseReportsContext.Provider>;
}



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/ExpenseReportsContext.js